export function isValidURL(str) {
    if (str === "about:blank") {
        return true;
    }
    const pattern = new RegExp("^(https?:\\/\\/)" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
        "(\\?)?([;&a-z\\d\\/#\\?%_.~+=-]*)?", "i");
    return !!pattern.test(str);
}
